'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMetadata = exports.createMetadata = exports.fetchMetadata = exports.deserializeMetadata = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var deserializeMetadata = exports.deserializeMetadata = function deserializeMetadata(_ref) {
  var id = _ref.id,
      _ref$labels = _ref.labels,
      labels = _ref$labels === undefined ? [] : _ref$labels,
      type = _ref.type;
  return (0, _keys2.default)(labels).reduce(function (keys, key) {
    return _extends({}, keys, _defineProperty({}, key, { id: id, value: labels[key], type: type }));
  }, {});
};

var fetchMetadata = exports.fetchMetadata = function fetchMetadata(_ref2) {
  var _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'Page' : _ref2$type;
  return _client.metadataAPI.get('/api/v1/metadata', { params: { token: token, type: type, ids: id } }).then(function (response) {
    return response.data.metadata;
  }).then(function (data) {
    return data[0];
  });
};

var createMetadata = exports.createMetadata = function createMetadata(_ref3) {
  var _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token,
      _ref3$id = _ref3.id,
      id = _ref3$id === undefined ? (0, _params.required)() : _ref3$id,
      _ref3$metadata = _ref3.metadata,
      metadata = _ref3$metadata === undefined ? (0, _params.required)() : _ref3$metadata,
      type = _ref3.type;
  return Promise.all((0, _keys2.default)(metadata).map(function (key) {
    return updateMetadata({ id: id, key: key, value: metadata[key], token: token, type: type });
  }));
};

var updateMetadata = exports.updateMetadata = function updateMetadata(_ref4) {
  var _ref4$token = _ref4.token,
      token = _ref4$token === undefined ? (0, _params.required)() : _ref4$token,
      _ref4$id = _ref4.id,
      id = _ref4$id === undefined ? (0, _params.required)() : _ref4$id,
      _ref4$key = _ref4.key,
      key = _ref4$key === undefined ? (0, _params.required)() : _ref4$key,
      _ref4$value = _ref4.value,
      value = _ref4$value === undefined ? (0, _params.required)() : _ref4$value,
      _ref4$type = _ref4.type,
      type = _ref4$type === undefined ? 'Page' : _ref4$type;
  return _client.metadataAPI.post('/api/v1/metadata', { id: id, key: key, token: token, type: type, value: value });
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/metadata/everydayhero/index.js
// module id = 1322
// module chunks = 0